import { Box, Container, Paper, Tab, Tabs, Typography } from '@mui/material';
import { BarChart3, FileText } from 'lucide-react';
import { FC, memo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { appBarHeight } from 'src/constants/layout';

import BillingPerformanceSection from './BillingPerformanceSection';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: FC<TabPanelProps> = ({ children, value, index }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`performance-tabpanel-${index}`}
    aria-labelledby={`performance-tab-${index}`}
    style={value === index ? { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 } : undefined}
  >
    {value === index && (
      <Box sx={{ pt: 1, pb: 2, display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        {children}
      </Box>
    )}
  </div>
);

const PerformanceManagementPresenter: FC = memo(() => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <>
      <Helmet>
        <title>実績管理 - LOG</title>
      </Helmet>
      <Box
        sx={{
          bgcolor: 'background.paper',
          height: `calc(100vh - ${appBarHeight}px)`,
          display: 'flex',
          flexDirection: 'column',
          p: 1,
          overflow: 'hidden',
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            flex: 1,
            mb: 1,
            minHeight: 0,
            overflow: 'hidden',
          }}
        >
          {/* タイトル */}
          <Box display="flex" alignItems="center" gap={2} sx={{ height: 70 }}>
            <Box
              sx={{
                p: 1,
                bgcolor: 'primary.main',
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <BarChart3 size={20} color="white" />
            </Box>
            <Typography variant="h3" fontWeight="bold">
              実績管理
            </Typography>
          </Box>

          <Paper
            sx={{
              flex: 1,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
            }}
          >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={currentTab}
                onChange={handleTabChange}
              >
                <Tab
                  label={(
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <FileText size={18} />
                      請求・支払実績
                    </Box>
                  )}
                />
              </Tabs>
            </Box>

            <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', px: 2 }}>
              <TabPanel value={currentTab} index={0}>
                <BillingPerformanceSection />
              </TabPanel>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
});

export default PerformanceManagementPresenter;
